import {default as Modal} from './modal.js';
import * as moment from 'moment';
import * as util from './util';
import customSelect from './customselect';
import customInputNumber from './form-number';
import {default as Preloader} from './preloader.js';

function BookingAddonForm($form) {
    this.$form = $form;

    this.initBooking();

	$('body').on('click', '.btn-continue', function(e) {
		const data = JSON.parse($('.booking_request_data').val());

		let grooms = [];

		$.each(data.rooms, function(index, item) {
			grooms.push({
				item_id: item.roomId,
				item_name: item.name,
				item_category: 'Accommodation',
				price: item.price,
				index: index
			});
		});

		dataLayer.push({
			"ecommerce": null,
			"event": 'begin_checkout',
			"ecommerce": {
				"currency": data.currency,
				"value": data.totals.total,
				"items": grooms
			}
		});
	});
}

BookingAddonForm.prototype.handleReloadSuccess = function(data) {
    const $form = this.$form;

    const $summary = $form.find('.summary .panel-body');
    $summary.html(data.summary_html);

    $form.find('.side .panel').each(function(index, panel) {
        if ($(panel).is('.summary, .continue')) {
            $(panel).show();
        }
    });
}

BookingAddonForm.prototype.reload = function() {
    Preloader.start();

    const $form = this.$form;
    const fetchUrl = $form.attr('data-update-url');
    const formData = $form.serialize();

    const $summary = $form.find('.side .summary');
    const $summaryPanelBody = $summary.find('.panel-body');

    const _this = this;

    $.ajax(fetchUrl, {
        data: formData,
        method: 'POST'
    }).done(function(responseData) {
        Preloader.end(); 

        _this.handleReloadSuccess(responseData.data);
    });
};

BookingAddonForm.prototype.initBooking = function() {
    const _this = this;

    const $form = this.$form;

    const $packages = $form.find('.packages-list');

    $form.on('click', '.view-package', function(e) {
        e.preventDefault();

        const $selectedPackage = $(this).find('.selected-package');
        const $packagePanel =  $(this).parents('.subpanel.package');
        $packagePanel.addClass('opened');   
        
        const fetchUrl = $(this).attr('data-view-url');

        $.ajax(fetchUrl, {
            method: 'GET'
        }).done(function(responseData) {
            Modal.show('addon-modal', {
                'onShown': function($modal) {
                    const $modalBody = $modal.find('.modal-body');
                    $modalBody.html(responseData.data.addon_html);
                    
                    const $deal = $modalBody.find('.deal');
                    const basePrice = parseFloat($deal.attr('data-price-value'));
                    const $adultsField = $modalBody.find('.addon-package-adults');

					customInputNumber($adultsField);

                    $adultsField.on('change', function(e) {
                        const $total = $modalBody.find('.total');
                        const adults = parseInt($adultsField.val());

                        $total.find('.value').html(adults * basePrice);
                    });
                    $modalBody.find('.add-package').on('click', function(e) {
                        e.preventDefault();

                        const $selectedPackageForm = $(this).parents('form.select-package');

                        const selectedPackageId = $selectedPackageForm.find('.addon-package-id').val();
                        const selectedPackageAduts = $selectedPackageForm.find('.addon-package-adults').val();
                        const selectedPackageNights = $selectedPackageForm.find('.addon-package-nights').val();

                        $form.find('.selected-package-id').val(selectedPackageId);
                        $form.find('.selected-package-adults').val(selectedPackageAduts);

                        $selectedPackage.addClass('selected');
                        $selectedPackage.html($modalBody.html());

                        $packages.find('.package.selected').removeClass('selected');
                        $packages.find('.package[data-idx=' + selectedPackageId + ']').addClass('selected');

                        Modal.hide();

                        _this.reload();
                    });
                }
            });
        });
    });

    $form.on('click', '.remove-package', function(e) {
        e.preventDefault();

        $(this).parents('.subpanel.package').removeClass('selected');

        $form.find('.selected-package-id').val('');
        $form.find('.selected-package-adults').val('');
        $form.find('.selected-package-nights').val('');

        _this.reload();
    });

    $form.on('change', '.addon-package-adults', function(e) {
        e.preventDefault();

        const selectedPackageAduts = $(this).val();

        $form.find('.selected-package-adults').val(selectedPackageAduts);
    });

    $form.on('change', '.addon-package-nights', function(e) {
        e.preventDefault();

        const selectedPackageNights = $(this).val();

        $form.find('.selected-package-nights').val(selectedPackageNights);
    });

}

export default BookingAddonForm;